import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initTelemetry, trackException } from '@/lib/telemetry';
import { validateEnv } from '@/lib/env';
import '@/theme/globals.css';

// 1. Validate env early — prefer a clear error to a mysterious runtime failure.
validateEnv();

// 2. Initialize telemetry BEFORE rendering so the first page-view event lands.
initTelemetry();

// 3. Catch unhandled errors and route them to App Insights.
window.addEventListener('error', (e) => trackException(e.error ?? e.message));
window.addEventListener('unhandledrejection', (e) => trackException(e.reason));

// 4. Mount.
const container = document.getElementById('root');
if (!container) {
  throw new Error('AgentStudio.Web: #root element missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
